const ROUTES = {
    BASE: '/1',
}

module.exports = ROUTES